import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DatePicker } from '@adsk/alloy-react-date-picker';
import { AlertInformationIcon } from '@adsk/alloy-react-icon';
import Tooltip from '@adsk/alloy-react-tooltip';
import { useLocale } from '@adsk/alloy-react-locale';
import { DATE_FORMAT } from '@adsk/acs-admin-ui-components-helpers';
import { DatePickerCustomFooter } from '@adsk/acs-admin-ui-components-shared-components';
import FieldWrapper from '../FieldWrapper';

const DateField = ({ date, isEditing, maxDate, minDate, onChange, title }) => {
  const { T, locale: localeName } = useLocale(({ locale }) =>
    require(`../../../../i18n/${locale}.json`)
  );
  const tooltip = (
    <Tooltip
      css={{ maxWidth: 'inherit', display: 'inline-block' }}
      content={T.translate('PROJECT_DATES_TOOLTIP_CONTENT')}
      placement={Tooltip.PLACEMENTS.RIGHT}
    >
      <AlertInformationIcon />
    </Tooltip>
  );
  let content = T.translate('PROJECT_NOT_AVAILABLE');

  if (isEditing) {
    content = (
      <DatePicker
        onChange={onChange}
        value={date}
        minDate={minDate}
        maxDate={maxDate}
        renderFooter={DatePickerCustomFooter}
      />
    );
  } else if (date) {
    const dateTime = moment(date).locale(localeName);
    content = (
      <time dateTime={dateTime.format()}>{dateTime.format(DATE_FORMAT)}</time>
    );
  }

  return (
    <FieldWrapper isEditing={isEditing} title={title} tooltip={tooltip}>
      {content}
    </FieldWrapper>
  );
};

DateField.propTypes = {
  date: PropTypes.instanceOf(Date),
  isEditing: PropTypes.bool,
  maxDate: PropTypes.instanceOf(Date),
  minDate: PropTypes.instanceOf(Date),
  onChange: PropTypes.func,
  title: PropTypes.string,
};

export default DateField;
